module.exports={turnstile_modal:{message:"Проверка сведений о безопасности"}};